module.exports = __webpack_public_path__ + "media/images/lb/439-39625c5256000805bbfd8e76bdf59c01.svg";